import { useEffect, useRef, useState } from 'react'
import {
  Overlay,
  Badge,
  Description,
  Button,
  Image
} from './styles'
import { useTour } from '../../contexts/tour'
import ArrowTopImg from '../../assets/images/defaults/arrow_top_tour.png'
import ArrowRightImg from '../../assets/images/defaults/arrow_right_tour.png'
import { t } from '../../adapters/translate/translate'
// import { usePage } from '../../contexts'

const arrowImages = {
  top: ArrowTopImg,
  right: ArrowRightImg,
  bottom: ArrowRightImg
}

const Tour = () => {
  const [currentArrowImage, setCurrentArrowImage] = useState<string>('')
  const badgeRef = useRef<HTMLDivElement | null>(null)
  // const { toggleHeader } = usePage()
  const { isOpen, currentStep, handleNextStep, currentOffset, tourWasCompleted } = useTour()
  const [displayTour, setDisplayTour] = useState('none')

  function updateOffset () {
    if (badgeRef.current && currentOffset && currentStep) {
      const xTemp = window.innerWidth < 768 ? 0 : 190
      let additionalX = 0
      let additionalY = 0

      // Definindo a posição horizontal do badgeRef com base no currentStep
      if (currentStep.id === 2) {
        additionalX = 0.2 * currentOffset.width // 20% da largura do currentOffset
      }

      // Definindo a posição vertical do badgeRef com base no currentStep e na direção da seta
      if (currentStep.arrowDirection === 'right') {
        additionalY = 0.5 * currentOffset.height // 50% da altura do currentOffset
      } else {
        additionalY = currentOffset.height
      }

      // Posicionamento final do badgeRef
      let topPosition = currentOffset.y + additionalY + 5
      let leftPosition = currentOffset.x - xTemp - additionalX

      if (currentStep.className === 'tour-1') {
        topPosition = topPosition + 50
        leftPosition = leftPosition + 1
      }

      if (currentStep.className === 'tour-2') {
        if (window.innerWidth < 500) {
          topPosition = topPosition + 10
          leftPosition = leftPosition - 190
        }
      }

      if (currentStep.className === 'tour-3') {
        if (window.innerWidth < 500) {
          topPosition = topPosition + 50
          leftPosition = leftPosition + 10
        }
      }

      if (currentStep.className === 'tourApproval-1' || currentStep.className === 'tourApproval-2') {
        if (window.innerWidth < 500) {
          topPosition = topPosition + 10
          leftPosition = leftPosition - 140
        }
      }

      // Aplicando as propriedades de estilo ao badgeRef
      badgeRef.current.style.top = `${topPosition}px`
      badgeRef.current.style.left = `${leftPosition}px`
    }
  }

  function loadCurrentStep () {
    setCurrentArrowImage(arrowImages[currentStep.arrowDirection])
  }

  function loadComponentSettings () {
    if (!badgeRef.current) {
      console.log('Without badge ref')
    }
  }

  useEffect(() => {
    const timer = setTimeout(() => updateOffset(), 100)

    loadCurrentStep()

    return () => {
      clearTimeout(timer)
    }
  }, [currentOffset, currentStep, isOpen, tourWasCompleted])

  useEffect(() => {
    loadComponentSettings()
  }, [currentOffset])

  useEffect(() => {
    setTimeout(() => setDisplayTour(isOpen ? 'flex' : 'none'), 1000)
  }, [isOpen])

  return (
    <Overlay style={{ display: displayTour }}>
      <Badge ref={badgeRef}>
        <Image direction={currentStep.arrowDirection} src={currentArrowImage} />
        <Description>{t(currentStep.label)}</Description>
        <Button onClick={handleNextStep}>Ok</Button>
      </Badge>
    </Overlay>
  )
}

export default Tour
